/*
 * @Author: libo 
 * @Date: 2020-11-13 16:49:58 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-10-11 15:40:44
 */

<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    :maskClosable="maskClosable"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
          <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false">
            <!--
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-model-item :label="$t('创建时间')">
                <a-input v-model="['createTime',validatorRules.createTime]" placeholder="" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('更新时间')">
                <a-input v-model="['updateTime',validatorRules.updateTime]" placeholder="" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('操作员')">
                <a-input v-model="['createBy',validatorRules.createBy]" placeholder="" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          -->
            <a-row :gutter="16">
              <!--
            <a-col :span="8">
              <a-form-model-item :label="$t('厂商代码')">
                <a-input v-model="['mtComCode',validatorRules.mtComCode]" :placeholder="$t('请输入厂商代码')" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            -->
              <a-col :span="8">
                <a-form-model-item :label="$t('水表厂商')" prop="mtComName">
                  <a-input v-model="model.mtComName" :placeholder="$t('请输入水表厂商')" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('表类型')" prop="mtCode">
                  <a-select v-model="model.mtCode" :placeholder="$t('请选择表类型')" :disabled="disableSubmit">
                    <a-select-option v-for="(data,index) in userTypeList" :key="data.id" :value="data.id">
                      <a-tooltip>
                        <template slot="title">
                          {{data.mtName}}
                        </template>
                        {{data.mtName}}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('册号')" prop="mtVolumeNo">
                  <a-input v-model="model.mtVolumeNo" :placeholder="$t('请输入册号')" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-divider />
              <a-col :span="8">
                <a-form-model-item :label="$t('表编号')" prop="meterId">
                  <a-input v-model="model.meterId" :placeholder="$t('请输入表编号')" :disabled="disableSubmit||!!this.model.id"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('表口径')" prop="mtCaliber">
                  <a-select v-model="model.mtCaliber" :placeholder="$t('请选择表口径')" :disabled="disableSubmit">
                    <a-select-option v-for="(data,index) in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                      DN{{data.mtCaliber}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('水表用途')" prop="mtUseType">
                  <j-dict-select-tag :disabled="disableSubmit" v-model="model.mtUseType" :placeholder="$t('请选择水表用途')"
                    dictCode="mtUseType" style="width:100%" />
                </a-form-model-item>
              </a-col><a-divider />
              <a-col :span="8">
                <a-form-model-item :label="$t('运营商')" prop="mtIotType">
                  <j-dict-select-tag :disabled="disableSubmit||model.mtState === 1" v-model="model.mtIotType" 
                    :placeholder="$t('请选择运营商')" dictCode="mtIotType" style="width:100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('IMEI号')" prop="mtImei">
                  <a-input :disabled="disableSubmit" v-model="model.mtImei" :placeholder="$t('请输入IMEI号')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('SIM卡号')" prop="mtSim">
                  <a-input :disabled="disableSubmit" v-model="model.mtSim" :placeholder="$t('请输入SIM卡号')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('是否带阀')" prop="mtHasValve">
                  <j-dict-select-tag :disabled="disableSubmit" v-model="model.mtHasValve"
                    :placeholder="$t('请选择是否带阀')" :showSearch="false" dictCode="yn" style="width:100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('出厂日期')" prop="productionDate">
                  <a-date-picker show-time v-model="model.productionDate" value-format="YYYY-MM-DD HH:mm:ss" :placeholder="$t('请选择出厂日期')" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注')" prop="remark">
                  <a-textarea :disabled="disableSubmit" v-model="model.mtRemark" rows="3" :placeholder="$t('请输入备注')" style="width:100%" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { listSize } from '@/utils/util'
import {isEmptyObject} from'@/utils/validate'
export default {
  name: 'MeterinfoModal',
  components: {
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      maskClosable:false,
      formDisabled: false,
      model: {
        mtComName: '',
        mtCode: '',
        mtVolumeNo: '',
        meterId: null,
        mtCaliber: null,
        mtUseType: '',
        mtState: '',
        mtImei: null,
        mtSim: '',
        mtHasValve: '',
        mtIotType: ''
      },
      confirmLoading: false,
      userTypeList: [],  //表类型
      userCaliberList: [],  // 表口径
      url: {
        add: "/jeecg-charge/meter/meterinfo/add",
        edit: "/jeecg-charge/meter/meterinfo/edit",
        queryById: "/jeecg-charge/meter/meterinfo/queryById",
        userTypeList: "/jeecg-charge/meter/meterType/list",  //表类型请求地址
        userCaliberList: "/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
      },
    }
  },
  computed: {
    // i18n：校验消息使用 computed 以响应语言切换
    rules() {
      return {
        meterId: [
          //{ required: true, message: '请输入正确的表编号!', whitespace: true },
            {required:true, pattern:/^[+]{0,1}(\d{14})$/,message: this.$t('请输入正确的表编号!')}
          ],
        mtCode: [{ required: true, message: this.$t('请选择表类型！') }],
        mtVolumeNo:[{ required: false, pattern: /^\d+$/, message: this.$t('请输入正确的册号!') }],
        mtCaliber:  [{ required: true, message: this.$t('请选择表口径！') }],
        /*
        mtUseType:{  //水表用途
          rules:[
            {required:true, message:'请选择水表用途！'}
          ]
        },
        */
        mtState: [{ required: true, message: this.$t('请选择水表当前状态！') }],
        /*
        mtComCode:[
            {required:true, message:'请输入厂商代码！'}
          ],
        */
        /*
         mtComName:[
             {required:true, message:'请输入水表厂商！'}
           ]
         */
      }
    }
  },
  watch: {
    'model.mtCode': {
      handler:function(newV,oldV){
        let currentMeterTypeObj = {}
        for(let i =0;i<this.userTypeList.length;i++) {
          if(this.userTypeList[i].id == newV) {
            currentMeterTypeObj = this.userTypeList[i];
            break;
          }
        }
        console.log(currentMeterTypeObj)
        if(!isEmptyObject(currentMeterTypeObj)) {
          if(currentMeterTypeObj.mtCode== 'Y17-N') {
              // 三川
            this.rules.meterId[0].pattern = /^[+]{0,1}(\d{12})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(12位数字)')
          }else if(currentMeterTypeObj.mtCode== 'Y18-17'||currentMeterTypeObj.mtCode== 'Y18-N') {
             // 贝林或者贝林在三川表
            console.log('currentMeterTypeObj.mtCode== Y18-17')
            this.rules.meterId[0].pattern = /^(3378\d{10})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(3378开头14位数字)')
            // this.$set(this.model,'meterId','3378'+this.model.meterId?this.model.meterId:'');
          }else{
            this.rules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(14位数字)')
          }
        }else{
          this.rules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
          this.rules.meterId[0].message = this.$t('请输入正确的表编号(14位数字)')
        }
        if(this.model.meterId!==null&&this.model.meterId!=='') {
          this.$nextTick(()=> {
            this.$refs.formModal.validateField("meterId")
          })
        }
        if(this.model.id){
          this.$nextTick(()=>{
            this.$refs.formModal.clearValidate('meterId');
          });
        }
      }
    }
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.visible = true
      this.model = Object.assign(this.model, record);
      // this.$nextTick(() => {
      //   this.$refs.formModal.resetFields();
      // })
      if(this.model.id){
        this.$nextTick(()=>{
          this.$refs.formModal.clearValidate('meterId');
        });
        if(!isEmptyObject(this.model)) {
          if(this.model.mtCodeName== 'Y17-N') {
            // 三川
            this.rules.meterId[0].pattern = /^[+]{0,1}(\d{12})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(12位数字)')
          }else if(this.model.mtCodeName== 'Y18-17'||this.model.mtCodeName== 'Y18-N') {
            this.rules.meterId[0].pattern = /^(3378\d{10})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(3378开头14位数字)')
            // this.$set(this.model,'meterId','3378'+this.model.meterId?this.model.meterId:'');
          }else{
            this.rules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
            this.rules.meterId[0].message = this.$t('请输入正确的表编号(14位数字)')
          }
        }else{
          this.rules.meterId[0].pattern = /^[+]{0,1}(\d{14})$/
          this.rules.meterId[0].message = this.$t('请输入正确的表编号(14位数字)')
        }
      }
      this.queryUserTypeList()
      this.queryUserCaliberList()
    },
    close() {
      console.log("关闭事件")
      this.$emit('close');
      this.visible = false;
      this.$refs.formModal.resetFields()
      this.model = this.$options.data.call(this).model
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.formModal.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let formData = Object.assign({}, this.model);
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
            formData.id = this.model.id;
          }

          formData.mtComCode = this.model.meterId.substr(0, 4);
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success && res.code == 200) {
              that.$message.success(res.message || this.$t('新增成功'));
              setTimeout(() => {
                that.$emit('ok');
                this.close();
              }, 400)
            } else {
              this.$error({
                title: this.$t('操作失败'),
                content: res.message,
              });
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }
      })
    },
    queryUserTypeList() {   //表类型请求
      let params = { pageNo: 1, pageSize: listSize }
      getAction(this.url.userTypeList, params).then((res) => {
        if (res.success) {
          this.userTypeList = res.result.records;
        }
      })
    },
    queryUserCaliberList() {   //表口径请求
      let params = { pageNo: 1, pageSize: listSize }
      params.column = 'mtCaliber';
      params.order = 'asc';
      getAction(this.url.userCaliberList, params).then((res) => {
        if (res.success) {
          this.userCaliberList = res.result.records;
        }
      })
    },
    submitCallback() {
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped lang="less">
</style>